import { useApolloClient } from '@apollo/client';
import { useCallback } from 'react';
import {
    DeleteGiftVoucherDocumentDocument,
    type DeleteGiftVoucherDocumentMutation,
    type DeleteGiftVoucherDocumentMutationVariables,
} from '../../../../../api/mutations/deleteGiftVoucherDocument';

const useDeleteGiftVoucherDocument = (token?: string, giftVoucherId?: string) => {
    const apolloClient = useApolloClient();

    return useCallback(
        async (uploadId: string) => {
            if ((!giftVoucherId && !token) || !uploadId) {
                return null;
            }

            const { data } = await apolloClient.mutate<
                DeleteGiftVoucherDocumentMutation,
                DeleteGiftVoucherDocumentMutationVariables
            >({
                mutation: DeleteGiftVoucherDocumentDocument,
                variables: {
                    giftVoucherId,
                    token,
                    uploadId,
                },
            });

            return !!data?.giftVoucher;
        },

        [apolloClient, giftVoucherId, token]
    );
};

export default useDeleteGiftVoucherDocument;
